import { Box } from '@mui/material';
import type { ReactNode } from 'react';
import type { SxProps, Theme } from '@mui/material/styles';
import { osirisTokens } from '@/theme/tokens';
import { SectionHeader } from './SectionHeader';

interface PanelProps {
  title?: ReactNode;
  headerRight?: ReactNode;
  children: ReactNode;
  className?: string;
  sx?: SxProps<Theme>;
  contentSx?: SxProps<Theme>;
  /** Overrides applied to the section header (e.g. transparent background). */
  headerSx?: SxProps<Theme>;
  /** When true, removes default content padding (e.g. for maps, full-bleed lists). */
  bleed?: boolean;
}

export function Panel({
  title,
  headerRight,
  children,
  className,
  sx,
  contentSx,
  headerSx,
  bleed = false,
}: PanelProps) {
  return (
    <Box
      className={`panel${className ? ' ' + className : ''}`}
      sx={[
        {
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
          minHeight: 0,
          bgcolor: osirisTokens.bg.page,
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {title !== undefined && <SectionHeader title={title} right={headerRight} sx={headerSx} />}
      <Box
        className="panel-content"
        sx={[
          {
            flex: 1,
            minWidth: 0,
            minHeight: 0,
            overflowX: 'hidden',
            overflowY: 'auto',
            p: bleed ? 0 : 1.5,
          },
          ...(Array.isArray(contentSx) ? contentSx : contentSx ? [contentSx] : []),
        ]}
      >
        {children}
      </Box>
    </Box>
  );
}
